/* eslint-disable react-hooks/exhaustive-deps */

import { useEffect, useState } from 'react';

import { useAtom } from 'jotai';
import { useRouter } from 'next/router';

import {
  getCategory,
  getNumberAdsByUser,
  republishAd,
} from '@/api/fetch/marketplace-api';
import { NbAdsByUserRequest } from '@/api/gen-protos/ads_pb';
import {
  CategoryByIDRequest,
  CategoryResponse,
} from '@/api/gen-protos/categories_pb';
import { ErorrsAtom, pageLoading, PageLoadingAction } from '@/lib/store';
import { User } from '@/models/user';
import useTransactions from '@/modules/profile/hooks/useTransactions';

import { UserDataAtom, AuthTokenAtom } from '../store/grpc-free-store';
import { IAdDetailItem } from '../types';

const useRepublishAdHook = (iAdDetailItem: IAdDetailItem) => {
  const [newAdLoader, setNewAdLoader] = useState(false);

  const [, updateErrorsAtom] = useAtom(ErorrsAtom);

  const [showConfirmDialog, setShowConfirmDialog] = useState<
    | {
        title: string;
        description: string;
        onClickConfirm: () => void;
      }
    | undefined
  >();

  const { balance } = useTransactions();

  const [userTotalAds, setUserTotalAds] = useState<{
    nbAds: number;
    defaultLimit: number;
  }>();
  const [userData] = useAtom<User>(UserDataAtom);
  const [authToken] = useAtom(AuthTokenAtom);
  const router = useRouter();
  const [categoryPrice, setCategoryPrice] = useState(0);

  const [, setIsLoading] = useAtom(pageLoading);

  const updateErrors = ({
    message,
    tabName,
  }: {
    message: string;
    tabName: string;
  }) => updateErrorsAtom({ message, tabName, type: 'set' });

  const resetErrors = () => {
    updateErrorsAtom({ message: '', tabName: '', type: 'init' });
  };
  const getUserBalance = async (subcategoryId: string) => {
    if (iAdDetailItem.subCategoryId && userData && userData.kcid) {
      const numberAdsByUser = new NbAdsByUserRequest();
      numberAdsByUser.setUserid(userData?.kcid);
      numberAdsByUser.setSubcategoryid(subcategoryId);
      getNumberAdsByUser(numberAdsByUser, authToken)
        .then((response) => {
          setUserTotalAds({
            nbAds: response?.getNbadsbyuser(),
            defaultLimit: response.getDefaultlimit(),
          });
        })
        .catch(() => {
          updateErrors({
            tabName: 'newAd_details',
            message: 'Erreur, veuillez réessayer plus tard',
          });
        });
    }
  };

  useEffect(() => {
    const categoryByIDRequest = new CategoryByIDRequest();

    categoryByIDRequest.setId(iAdDetailItem.category as string);
    getCategory(categoryByIDRequest).then(
      (subCategoryParamsResponse: CategoryResponse) => {
        setCategoryPrice(
          subCategoryParamsResponse
            .getCategory()
            ?.getProductpriceMap()
            .get('insertions') as number
        );
      }
    );
    getUserBalance(iAdDetailItem.subCategoryId as string);
  }, [iAdDetailItem.category]);

  const postAd = async () => {
    resetErrors();
    setIsLoading(PageLoadingAction.Start);
    setNewAdLoader(true);

    await republishAd(authToken, iAdDetailItem.id)
      .then((r) => {
        setIsLoading(PageLoadingAction.Stop);
        setNewAdLoader(false);
        router.push(`/item/${r?.getAd()?.getAdid()}`);
      })
      .catch((error) => {
        setNewAdLoader(false);
        if (error === 'not enough balance') {
          // setShowConfirmDialog({
          //   title: "Vous n'avez pas de solde suffisant",
          //   description: `Veuillez acheter des t-jetons pour bénéficier de ce service. Il vous manque ${
          //       categoryPrice - balance
          //   } t-jetons`,
          //   onClickConfirm: () => router.push('/buy-tokens'),
          // });
          router.push('/buy-tokens');
        } else {
          updateErrors({
            tabName: 'newAd_contact',
            message: ' Erreur, veuillez réessayer plus tard',
          });
        }

        setIsLoading(PageLoadingAction.Stop);
      });
  };

  const onClickConfirmRunBuyToken = async () => {
    setShowConfirmDialog(undefined);
    await postAd();
  };

  const startPostProcess = async () => {
    if (
      !categoryPrice ||
      (userTotalAds && userTotalAds?.defaultLimit >= userTotalAds?.nbAds)
    ) {
      await postAd();
    } else if (balance < categoryPrice) {
      setShowConfirmDialog({
        title: "Vous n'avez pas de solde suffisant",
        description: `Veuillez acheter des t-jetons pour bénéficier de ce service. Il vous manque ${Math.abs(
          balance - categoryPrice
        )} t-jetons`,
        onClickConfirm: () => router.push('/buy-tokens'),
      });
    } else {
      setShowConfirmDialog({
        title: 'Votre annonce sera publiée',
        description: `${categoryPrice} t-jetons seront débités de votre solde.`,
        onClickConfirm: onClickConfirmRunBuyToken,
      });
    }
  };

  const confirmTokenPayment = () => {
    postAd();
  };

  return {
    startPostProcess,

    showConfirmDialog,
    setShowConfirmDialog,
    confirmTokenPayment,

    newAdLoader,

    updateErrors,
    resetErrors,
  };
};

export default useRepublishAdHook;
